<template>
    <router-view />
</template>

<script>
export default {
    name: 'App',
    watch: {
        '$route': function (to, from) {
            if (document.getElementsByClassName('homeBox')[0]) {
                document.getElementsByClassName('homeBox')[0].scrollTop = 0
                document.documentElement.scrollTop = 0
            }
        }
    },
}
</script>

<style lang="scss" type="text/scss">
.router-fade-enter-active,
.router-fade-leave-active {
    transition: opacity 0.3s;
}
.router-fade-enter,
.router-fade-leave-active {
    opacity: 0;
}
body{padding-right:0 !important;}
</style>



// WEBPACK FOOTER //
// src/jvsit/App.vue